export default __webpack_public_path__ + "static/media/LeaMeyerRodarte.24f0865f.jpg";